import DesignDeployment from "public/network-services/design-deploy.png";

export const INTRO_CONSTANTS = {
  title: "Network Design & Deployment, Built for What’s Next",
  description: [
    "Network design and deployment is a strategic process that shapes the foundation of your digital infrastructure. OneMind delivers wired, wireless, and cloud-native network architectures that are secure, scalable, and optimized for performance.",
    "From initial planning through implementation and ongoing optimization, every deployment is built to support evolving business needs—ensuring resilience, agility, and seamless connectivity across your entire ecosystem.",
  ],
  image: DesignDeployment,
  imageHeight: "300px",
};
